module.exports = __webpack_public_path__ + "static/icons/icon-discount-76379acc1aad73cccaa588179f358528.svg";